import ScientificText from "../../../../components/ScientificText";
import { SectionTitle } from "../../../../components/ui/SectionTitle";
import type { ArticlePageArticle } from "../../hooks/useArticleData";

interface ArticleSectionAbstractProps {
  article: ArticlePageArticle;
}

export function ArticleSectionAbstract({
  article,
}: ArticleSectionAbstractProps) {
  const abstractText = article.abstractText;

  if (!abstractText) return null;

  return (
    <section data-gtm-section="abstract" data-gtm-order="2">
      <SectionTitle title="Abstract" className="mb-4" />
      {/* `whitespace-pre-line`: 56% of stored abstracts carry paragraph line
          breaks (structured BACKGROUND/METHODS/RESULTS abstracts) that HTML
          would otherwise collapse into one blob. */}
      <p className="whitespace-pre-line">
        <ScientificText>{abstractText}</ScientificText>
      </p>
    </section>
  );
}
